import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Certains edge/proxy (ex. Cloudflare en prod) bloquent la méthode HTTP DELETE.
// On convertit tout DELETE en POST + en-tête d'override ; le backend le re-route en DELETE.
api.interceptors.request.use((config) => {
  if ((config.method || "").toLowerCase() === "delete") {
    config.method = "post";
    config.headers = { ...(config.headers || {}), "X-HTTP-Method-Override": "DELETE" };
    if (config.data === undefined) config.data = {};
  }
  return config;
});

// Redirige vers /login sur 401 (session expirée / non authentifié)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/")) {
      if (window.location.pathname !== "/login" &&
          !window.location.pathname.startsWith("/reserver") &&
          !window.location.pathname.startsWith("/valider-attente")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fmtEUR = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(
    Number(v || 0)
  );

// Noms en MAJUSCULES ; prénoms : 1re lettre de chaque prénom en majuscule, reste en minuscule
export const fmtLastName = (s) => (s || "").trim().toUpperCase();
export const fmtFirstName = (s) =>
  (s || "").trim().toLowerCase().replace(/(^|[\s\-'])([a-zà-ÿ])/g, (m, sep, ch) => sep + ch.toUpperCase());
export const fmtPersonName = (first, last) =>
  `${fmtFirstName(first)} ${fmtLastName(last)}`.trim();

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return v;
  }
};


// CB 3x : 3 échéances mensuelles (J+0, J+30, J+60). On ne propose le 3x que si la
// dernière échéance (J+60) ne dépasse pas la date d'arrivée du séjour.
export const cb3xAllowed = (arrivalDate) => {
  if (!arrivalDate) return true;
  const arrival = new Date(arrivalDate);
  if (isNaN(arrival.getTime())) return true;
  const last = new Date();
  last.setDate(last.getDate() + 60);
  return last <= arrival;
};
